import settingRoutes from './route';

export default settingRoutes;